import styled, {css} from 'styled-components';

//Variables
import { Screen } from 'styles';

const MediumWrapperStyle = css`
  width: 100%;
`;

export const StyledElementWrapperCenter = styled.div`
  margin: 0 auto;
  padding: 0 15px;
  position: relative;
  width: 1170px;
  
  ${Screen.medium(MediumWrapperStyle)}
`;


// WEBPACK FOOTER //
// ./src/utils/styledElements/wrapperCenter/wrapperCenter.style.js